import React, { useRef, useState, useMemo } from 'react';
import Box from '@mui/material/Box';
import { StyledFieldBox, StyledGridContainer,  } from '../../Components/Styled/index';
import { handleValidateCodevalue, STATIC_ENTITY_CONFIG } from '../../Utility/constant';
import { useSelector } from 'react-redux';
import { WhoColumns } from '../../Components/WhoColumns';
import SelectBoxWithLabel from '../../Components/SelectBoxWithLable';
import TextFiledWithLabel from '../../Components/TextFieldWithLabel';
import NumericTextField from '../../Components/NumericTextfield';
import CommonEmail from '../../Components/CommonEmail';
import CommonPoc from '../../Components/CommonPoc';
import { ChooseProductType } from '../../Components/ChooseProductType';
import { getEntityColumns } from '../../Utility/apiHelper';
import PhoneNumberField from '../../Components/PhoneNumberField';
import './Customer.css';

const SearchCustomer = ({handleOnChange,entityDetails }) => {
    const internationalise = useSelector(state => state?.internationalise?.currentHashMapData)
    const inputRef = useRef(null);
    const specificRolePermission = useSelector(state => state?.owner?.rolebasedData);
         const [isVisible , setIsVisible] = useState(false)
    
     const allEntityData = useSelector((state) => state?.customization?.allEntityData || []);

    const customerTextfieldsData = useMemo(() => {
        const data = getEntityColumns(allEntityData, "CUSTOMER");

        return Object.keys(data).length > 0
            ? data
            : STATIC_ENTITY_CONFIG?.CUSTOMER;
    }, [allEntityData]);
    return (
        <Box className="search-customer-form-box">
           <StyledGridContainer>
    <TextFiledWithLabel id="id" 
        label={handleValidateCodevalue(internationalise,'CUST_SEARCH_CUSTOMER_ID')}
        type = "number"
        name="id"
        InputLabelProps={{
            shrink: true,
        }}
        inputRef={inputRef}
        handleOnChange={handleOnChange}
        value={entityDetails?.id}
    />
    <TextFiledWithLabel 
        name="leadId"
        inputRef={inputRef}
        id="lead" 
        label={handleValidateCodevalue(internationalise,'CUST_SEARCH_LEAD_ID')}
        handleOnChange={handleOnChange}
        value={entityDetails?.leadId}
        InputLabelProps={{
            shrink: true,
        }}
    />
    <SelectBoxWithLabel
        id="status" 
        name="status"
        value={entityDetails?.status}
        handleOnChange={handleOnChange}
        optionMenuItem={[{label:"CUSTOMER_STATUS_ACTIVE"}, {label:"CUSTOMER_STATUS_INACTIVE"}]}
        label={handleValidateCodevalue(internationalise,'CUST_SEARCH_STATUS')} 
    />
    {customerTextfieldsData?.firstName?.visibility &&
    <TextFiledWithLabel 
        id="searchname" 
        label={handleValidateCodevalue(internationalise,'CUST_SEARCH_FIRSTNAME')} 
        name="firstName"
        InputLabelProps={{
            shrink: true,
        }}
        inputRef={inputRef}
        handleOnChange={handleOnChange}
        value={entityDetails?.firstName}
    />
    }
    {customerTextfieldsData?.lastName?.visibility &&
    <TextFiledWithLabel 
        id="searchname" 
        label={handleValidateCodevalue(internationalise,'CUST_SEARCH_LASTNAME')} 
        name="lastName"
        InputLabelProps={{
            shrink: true,
        }}
        inputRef={inputRef}
        handleOnChange={handleOnChange}
        value={entityDetails?.lastName}
    />
    }
    <PhoneNumberField
        name="phone"
        countryCodeName="phoneCountryCode"
        countryCode={entityDetails?.phoneCountryCode || "+91"}
        value={entityDetails?.phone}
        handleOnChange={handleOnChange}
    />
    <CommonEmail
        name = 'email'
        value={entityDetails?.email}
        helperText = ""
        handleOnChange={handleOnChange}
    />
                <ChooseProductType
                    value={entityDetails?.productId || ""}
                    searchState={entityDetails}
                    handleChangeSearchField={handleOnChange} 
                />

    </StyledGridContainer>
    <StyledFieldBox className="search-customer-field-box">
    <NumericTextField
        name="priceFrom"
        maxLength={15}
        value={entityDetails?.priceFrom}
        label={handleValidateCodevalue(internationalise, "CUST_SEARCH_TOTAL_VAL_MIN")} 
        handleOnChange={handleOnChange}
    />
    <NumericTextField
        name="priceTo"
        maxLength={15}
        value={entityDetails?.priceTo}
        label={handleValidateCodevalue(internationalise, "CUST_SEARCH_TOTAL_VAL_MAX")} 
        handleOnChange={handleOnChange}
    />
    </StyledFieldBox>

                <CommonPoc
                    handleOnChange={handleOnChange}
                    state={entityDetails}
                />
                <WhoColumns
                searchState = {entityDetails}
                handleOnChange = {handleOnChange}
                />
        </Box>
    );
}

export default SearchCustomer;
